var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { curveCatmullRomClosed, curveCatmullRom } from 'd3-shape';
import { isPolar } from '../../utils/coordinate';
import { Curve } from './curve';
export var Smooth = function Smooth(options, context) {
  var _options$alpha = options.alpha,
    alpha = _options$alpha === void 0 ? 0.5 : _options$alpha,
    rest = __rest(options, ["alpha"]);
  var coordinate = context.coordinate;
  return function () {
    var curve = isPolar(coordinate) ? curveCatmullRomClosed : curveCatmullRom;
    return Curve(Object.assign({
      curve: curve.alpha(alpha)
    }, rest), context).apply(void 0, arguments);
  };
};
Smooth.props = Object.assign(Object.assign({}, Curve.props), {
  defaultMarker: 'smooth'
});